module.exports = __webpack_public_path__ + "img/218.c9b749ab.png";